/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Category of a catalog item.
 */
export enum CatalogItemCategory {
  CatalogItemCategorySystem = 'system',
  CatalogItemCategoryApplication = 'application',
}
